export const CAPACITY = {
    dispatchTypeDefault: 'NORMAL',
    capacityDefault: 999999,
    maxCarrier: 4
}
